import { Component } from '@angular/core';
import { View } from './view.enum';

@Component({
    selector: 'ols-login',
    templateUrl: './login.component.html',
})
export class LoginComponent {
    public View = View;
    public shownView: View = View.LOGIN;
    public isShowingConfirmationBubble = false;

    constructor() {}

    public changeShownView(shownView: View): void {
        this.shownView = shownView;
    }

    public passwordResetSent() {
        this.changeShownView(View.LOGIN);
        this.isShowingConfirmationBubble = true;
    }
}
